/**
 * IMAGE ZOOM HANDLER
 * Gestiona el zoom de imágenes mediante un modal para evitar problemas de overflow/recorte.
 * Se integra globalmente y escucha clics en imágenes con clase .problem-image-small
 */

const ImageZoomHandler = {
    overlay: null,
    imageParams: null,

    init() {
        if (this.overlay) return; // Ya inicializado

        // Crear elementos del DOM
        this.overlay = document.createElement('div');
        this.overlay.className = 'image-zoom-overlay';

        const closeBtn = document.createElement('div');
        closeBtn.className = 'image-zoom-close';
        closeBtn.innerHTML = '✕';

        const imgContent = document.createElement('img');
        imgContent.className = 'image-zoom-content';
        imgContent.alt = 'Imagen ampliada';

        this.overlay.appendChild(closeBtn);
        this.overlay.appendChild(imgContent);
        document.body.appendChild(this.overlay);

        // Event Listeners
        this.overlay.addEventListener('click', () => this.close());

        // Delegación de eventos global para imágenes dinámicas
        document.addEventListener('click', (e) => {
            const target = e.target;
            // Verificar si es una imagen de problema (o dentro de un contenedor)
            if (target.tagName === 'IMG' &&
                (target.classList.contains('problem-image-small') ||
                    target.closest('.problem-image-inline'))) {

                e.stopPropagation();
                this.open(target.src);
            }
        });

        // Soporte para tecla ESC
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.overlay.classList.contains('active')) {
                this.close();
            }
        });

        console.log('🔍 [ImageZoom] Zoom Manager Initialized');
    },

    open(src) {
        const img = this.overlay.querySelector('img');
        img.src = src;
        this.overlay.classList.add('active');

        // Efecto de sonido (opcional)
        if (window.SoundService && window.SoundService.playSFX) {
            window.SoundService.playSFX('pop', 0.3); // Sonido suave
        }
    },

    close() {
        this.overlay.classList.remove('active');
        // Limpiar src después de la transición para evitar parpadeos
        setTimeout(() => {
            const img = this.overlay.querySelector('img');
            if (img && !this.overlay.classList.contains('active')) {
                img.src = '';
            }
        }, 300);
    }
};

// Exportar globalmente
window.ImageZoomHandler = ImageZoomHandler;

// Auto-inicializar al cargar
document.addEventListener('DOMContentLoaded', () => {
    ImageZoomHandler.init();
});
